import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

/**
 * meta: {
   navTheme: 'white', // 导航栏主题 white-白色（不填默认） black-黑色
   navThemeCustom: true, // 组件内自行处理导航栏主题
   navFixed: false, // 是否固定导航 - 不设置默认false
 }
 */
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "首页",
            keywords:
              "赛博威，赛博威科技，Cyberway，数字营销赋能专家，营销一体化解决方案，营销端数字化解决方案，数智营销费用管理，3A模型，企业数字化转型伙伴"
          }
        },
        {
          path: "/products",
          name: "products",
          component: resolve => require(["@/view/PageView"], resolve),
          redirect: "/products/mdm",
          meta: {
            title: "产品服务"
          },
          children: [
            {
              path: "tpm+",
              name: "TPM+",
              component: resolve => require(["@/view/products/TPM+"], resolve),
              meta: {
                title: "营销费用管理 Plus（TPM +）",
                keywords:
                  "营销费用管理平台，费用一体化管理平台，费控系统，营销费控系统，费用管理系统，TPM营销费用管理系统，营销费用闭环管理，ROI可视化，预算实时管控，AI赋能，全数据链打通"
              }
            },
            {
              path: "tpm",
              name: "TPM",
              component: resolve => require(["@/view/products/TPM"], resolve),
              meta: {
                title: "营销费用管理（TPM）",
                keywords:
                  "营销费用管理，费用一体化管理，费控系统，营销费控系统，费用管理系统，TPM营销费用管理系统，营销费用闭环管理，ROI可视化，预算实时管控，AI赋能，全数据链打通"
              }
            },
            {
              path: "mdm",
              name: "MDM",
              component: resolve => require(["@/view/products/MDM"], resolve),
              meta: {
                title: "主数据管理（MDM）",
                keywords:
                  "主数据管理，数据治理平台，数据统一管理，优化企业数据环境，数据治理解决方案"
              }
            },
            {
              path: "npi",
              name: "NPI",
              component: resolve => require(["@/view/products/NPI"], resolve),
              meta: {
                title: "产品创新协同平台",
                keywords:
                  "新品研发协同平台，研发协同系统，新品上市全链路追踪，品牌舆情监控，产品研发协同平台，价格监测，趋势洞察，产品储备，产品分析报告，新品分析"
              }
            },
            {
              path: "bi",
              name: "BI",
              component: resolve => require(["@/view/products/BI"], resolve),
              meta: {
                title: "全域商业洞察（BI）",
                keywords:
                  "全域数据商业洞察，数据资产梳理，业务洞察，数据治理，商业洞察主题库，全域数据汇集，场景化分析模型"
              }
            },
            {
              path: "ic",
              name: "IC",
              component: resolve => require(["@/view/products/IC"], resolve),
              meta: {
                title: "智慧社区",
                keywords:
                  "智慧社区综合管理平台，万物互联，商业O2O，数据云，数智社区生态链"
              }
            },
            {
              path: "sfa",
              name: "SFA",
              component: resolve => require(["@/view/products/SFA"], resolve),
              meta: {
                title: "销售能力自动化（SFA)",
                keywords:
                  "销售能力自动化，SFA销售自动化系统，销售自动化系统，终端执行，路线智能规划，门店拜访，库存盘点，下单补货"
              }
            },
            {
              path: "coi",
              name: "COI",
              component: resolve => require(["@/view/products/COI"], resolve),
              meta: {
                title: "消费者意见洞察",
                keywords:
                  "消费者意见洞察工具，品牌舆论追踪，全方位意见洞察，触达消费者需求，消费者洞察报告，消费者意见分析，客户满意度分析"
              }
            },
            {
              path: "dp",
              name: "DP",
              component: resolve => require(["@/view/products/DP"], resolve),
              meta: {
                title: "销售预测",
                keywords:
                  "销售预测系统，预测算力平台，销售预测一体化，优化供应链，强化预算管理"
              }
            },
            {
              path: "b2b",
              name: "B2B",
              component: resolve => require(["@/view/products/B2B"], resolve),
              meta: {
                title: "订货协同平台（B2B）",
                keywords:
                  "订货协同平台，订单校验追踪，订单管理，经销商管理，数据报表"
              }
            },
            {
              path: "sp",
              name: "SP",
              component: resolve => require(["@/view/products/SP"], resolve),
              meta: {
                title: "智慧石化",
                keywords:
                  "智能厂内物流管理，无人值守地磅，数据智能分析决策，降本增效，全面适配信创"
              }
            },
            {
              path: "som",
              name: "SOM",
              component: resolve => require(["@/view/products/SOM"], resolve),
              meta: {
                title: "系统运维",
                keywords:
                  "系统运维，IT服务中心，稳定的团队支持，全面的服务能力，完善的服务体系，统一数据管理、模块复用、需求快速响应"
              }
            },
            {
              path: 'ai-ops',
              name: 'AI-Ops',
              component:  resolve => require(["@/view/products/AIOps"], resolve),
                meta: {
                title: "AI运维数字员工",
                keywords:
                  ""
              }
            },
            {
              path: "cyber-insight",
              name: "CyberInsight",
              component: resolve => require(["@/view/products/CI"], resolve),
              meta: {
                title: "CyberInsight",
                keywords:
                  "咨询、数字营销咨询、系统调研、方案规划、项目评估、风险把控"
              }
            },
            {
              path: "cyber-tpm",
              name: "CyberTPM",
              component: resolve => require(["@/view/products/TPMC"], resolve),
              meta: {
                title: "CyberTPM",
                keywords:
                  "营销费用管理、TPM、TPE、TPO、流程自动化、营销链路闭环管理、Ai赋能、归因预测"
              }
            },
            {
              path: "AI",
              name: "AI",
              component: resolve => require(["@/view/products/AI"], resolve),
              meta: {
                title: "AI",
                keywords:
                  "AI"
              }
            },
            {
              path: "AI_box",
              name: "AI_box",
              component: resolve => require(["@/view/products/AI_box"], resolve),
              meta: {
                title: "AI_box",
                keywords:
                  "AI_box"
              }
            },
            {
              path: "AI_box_detail",
              name: "AI_box_detail",
              component: resolve => require(["@/view/products/AI_box_detail"], resolve),
              meta: {
                title: "AI详情",
                navFixed: true
              }
            },
            {
              path: "SaaS",
              name: "SaaS",
              component: resolve => require(["@/view/products/SaaS"], resolve),
              meta: {
                title: "产品创新平台（SaaS版）",
                keywords:
                  "产品创新平台（SaaS版）"
              }
            },
          ]
        },
        {
          path: "ai-scene",
          name: "ai-scene",
          component: resolve => require(["@/view/AiScene"], resolve),
          meta: {
            title: "AI 业务场景"
          }
        },
        {
          path: "/capabilities",
          name: "capabilities",
          component: resolve =>
            require(["@/view/capabilitiesDigital"], resolve),
          meta: {
            title: "数字化能力"
          }
        },
        {
          path: "/solutions",
          name: "industrySolutions",
          component: resolve => require(["@/view/PageView"], resolve),
          redirect: "/solutions/cases",
          meta: {
            title: "行业解决方案"
          },
          children: [
            {
              path: "cases",
              name: "Solutions",
              component: resolve =>
                require(["@/view/solutions/index"], resolve),
              meta: {
                title: "行业解决方案"
              }
            },
            {
              path: "cases/:id",
              name: "CaseDetail",
              component: resolve =>
                require(["@/view/solutions/detail"], resolve),
              meta: {
                title: "行业解决方案-案例",
                navThemeCustom: true
              }
            }
          ]
        },
        {
          path: "/goin",
          name: "goin",
          component: resolve => require(["@/view/PageView"], resolve),
          redirect: "/goin/about",
          meta: {
            title: "走进赛博威"
          },
          children: [
            {
              path: "about",
              name: "about",
              component: resolve => require(["@/view/goin/about"], resolve),
              meta: {
                title: "关于赛博威"
              }
            },
            {
              path: "join-us",
              name: "JoinUs",
              component: resolve => require(["@/view/goin/joinUs"], resolve),
              meta: {
                title: "加入我们"
              }
            },
            {
              path: "news",
              name: "News",
              component: resolve => require(["@/view/goin/news"], resolve),
              meta: {
                title: "品牌资讯",
                navFixed: true
              }
            },
            {
              path: "news/detail",
              name: "new",
              component: resolve => require(["@/view/goin/new"], resolve),
              meta: {
                title: "资讯详情",
                navFixed: true
              }
            },
            // {
            //   path: "contact",
            //   name: "Contact",
            //   component: resolve => require(["@/view/Contact"], resolve),
            //   meta: {
            //     title: "联系我们",
            //     navFixed: true
            //   }
            // },
            // {
            //   path: "contact2",
            //   name: "Contact2",
            //   component: resolve => require(["@/view/Contact2"], resolve),
            //   meta: {
            //     title: "联系我们",
            //     navFixed: true
            //   }
            // },
            {
              path: "contact-mobile",
              name: "ContactMobile",
              component: resolve => require(["@/view/ContactMobile"], resolve),
              meta: {
                title: "联系我们",
                navFixed: true
              }
            }
          ]
        },
        {
          path: "/three",
          name: "Three",
          component: resolve => require(["@/view/Three"], resolve),
          meta: {
            title: "3D模型"
          }
        },
        {
          path: "/three2",
          name: "Three",
          component: resolve => require(["@/view/Three-old"], resolve),
          meta: {
            title: "3D模型"
          }
        }
      ]
    },
    {
      path: "*",
      redirect: "/home"
    },
    {
      path: "/exhibition",
      name: "exhibition",
      component: resolve => require(["@/view/exhibition"], resolve),
      meta: {
        title: "第10届中国消费品行业CIO大会",
        }
    },
    {
      path: "/contact",
      name: "Contact",
      component: resolve => require(["@/view/Contact"], resolve),
      meta: {
        title: "联系我们",
        navFixed: true
      }
    },
    {
      path: "/contact2",
      name: "Contact2",
      component: resolve => require(["@/view/Contact2"], resolve),
      meta: {
        title: "联系我们",
        navFixed: true
      }
    },
    // {
    //   path: "/30thAnniversary",
    //   name: "30thAnniversary",
    //   component: resolve => require(["@/view/30thAnniversary"], resolve),
    //   meta: {
    //     title: "三十周年",
    //     navFixed: true
    //   }
    // },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js